// src/components/employee/EmployeeMobileLayout.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Box, 
  AppBar, 
  Toolbar, 
  Typography, 
  IconButton, 
  Menu, 
  MenuItem, 
  ListItemIcon,
  ListItemText,
  Divider
} from '@mui/material';
import { 
  AccountCircle, 
  Notifications,
  Person,
  Settings,
  Logout
} from '@mui/icons-material';
import shiftworksLogo from '../../assets/shiftworks-logo.svg';
import { useEmployeeAuth } from '../../hooks/useEmployeeAuth';

export default function EmployeeMobileLayout({ children, title = "ShiftWorks", employee }) {
  const navigate = useNavigate();
  const { logout } = useEmployeeAuth();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/employee/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
    handleMenuClose();
  };

  return (
    <Box sx={{ 
      minHeight: '100vh', 
      bgcolor: 'background.default',
      pb: 8 // Space for bottom navigation
    }}>
      {/* Mobile App Bar */}
      <AppBar position="static" elevation={1}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <img 
              src={shiftworksLogo} 
              alt="ShiftWorks" 
              style={{ 
                height: '32px', 
                width: 'auto',
                marginRight: '12px'
              }} 
            />
            <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
              {title}
            </Typography>
          </Box>
          
          <Box>
            <IconButton color="inherit" size="large">
              <Notifications />
            </IconButton>
            <IconButton 
              color="inherit" 
              size="large"
              onClick={handleMenuOpen}
            >
              <AccountCircle />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      {/* User Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {employee ? [
          <MenuItem key="user-info" disabled>
            <ListItemIcon>
              <Person />
            </ListItemIcon>
            <ListItemText 
              primary={`${employee.firstName} ${employee.lastName}`}
              secondary={employee.email}
            />
          </MenuItem>,
          <Divider key="divider" />,
          <MenuItem key="settings" onClick={handleMenuClose}>
            <ListItemIcon>
              <Settings />
            </ListItemIcon>
            <ListItemText primary="Settings" />
          </MenuItem>,
          <MenuItem key="logout" onClick={handleLogout}>
            <ListItemIcon>
              <Logout />
            </ListItemIcon>
            <ListItemText primary="Sign Out" />
          </MenuItem>
        ] : [
          <MenuItem key="settings" onClick={handleMenuClose}>
            <ListItemIcon>
              <Settings />
            </ListItemIcon>
            <ListItemText primary="Settings" />
          </MenuItem>,
          <MenuItem key="logout" onClick={handleLogout}>
            <ListItemIcon>
              <Logout />
            </ListItemIcon>
            <ListItemText primary="Sign Out" />
          </MenuItem>
        ]}
      </Menu>

      {/* Main Content */}
      <Box sx={{ 
        px: 2, 
        py: 3,
        maxWidth: '100%',
        margin: '0 auto'
      }}>
        {children}
      </Box>
    </Box>
  );
}
